// Normalization utilities for comparing model outputs across providers

export function normalize(value, kind = 'string') {
  if (value === null || value === undefined) return '';
  let s = String(value).trim();
  if (!s) return '';
  switch (kind) {
    case 'number':
      return s.replace(/[^\d]/g, '');
    case 'money':
      return s.replace(/[^\d]/g, '');
    case 'plate':
      return s.toUpperCase().replace(/[\s.]/g, '').replace(/-/g, '');
    case 'vin':
      return s.toUpperCase().replace(/\s+/g, '');
    case 'residentId':
      return s.replace(/[^\d]/g, '');
    case 'businessNo':
      return s.replace(/[^\d]/g, '');
    case 'date': {
      // parse yyyy-mm-dd / yyyy.mm.dd / yyyy/mm/dd / yyyy mm dd
      const m = s.match(/(20\d{2}|19\d{2})[./\-\s]?(\d{1,2})[./\-\s]?(\d{1,2})/);
      if (!m) return s.replace(/\s+/g, ' ');
      const y = m[1];
      const mo = String(m[2]).padStart(2, '0');
      const d = String(m[3]).padStart(2, '0');
      return `${y}-${mo}-${d}`;
    }
    case 'year': {
      const y = s.match(/(20\d{2}|19\d{2})/);
      return y ? y[1] : s.replace(/\s+/g, ' ');
    }
    default:
      return s.replace(/\s+/g, ' ');
  }
}

// CBM 자동 계산 함수
// CBM = FLOOR(길이 × 너비 × 높이 ÷ 1,000,000,000, 1)
function calculateCBM(length, width, height) {
  const l = parseFloat(length) || 0;
  const w = parseFloat(width) || 0;
  const h = parseFloat(height) || 0;
  
  if (l === 0 || w === 0 || h === 0) return null;
  
  // CBM = INT(길이 × 너비 × 높이 ÷ 1,000,000,000)
  const cbmValue = (l * w * h) / 1000000000;
  return Math.floor(cbmValue).toString(); // 정수로 변환 (예: 13)
}

export function compareFields(flash, pro, schema) {
  // CBM 자동 계산 추가
  const flashCBM = calculateCBM(flash?.length, flash?.width, flash?.height);
  const proCBM = calculateCBM(pro?.length, pro?.width, pro?.height);
  
  if (flashCBM) {
    flash = { ...flash, cbm: flashCBM };
  }
  if (proCBM) {
    pro = { ...pro, cbm: proCBM };
  }
  
  const rows = schema.map(f => {
    const fv = flash && Object.prototype.hasOwnProperty.call(flash, f.key) ? flash[f.key] : '';
    const pv = pro && Object.prototype.hasOwnProperty.call(pro, f.key) ? pro[f.key] : '';
    const fn = normalize(fv, f.kind);
    const pn = normalize(pv, f.kind);
    const match = pn !== '' && fn === pn;
    return { key: f.key, label: f.label, kind: f.kind, flash: fv, pro: pv, match };
  });
  const total = rows.length;
  const matched = rows.filter(r => r.match).length;
  const rate = Math.round((matched / (total || 1)) * 100);
  const mismatched = total - matched;
  return { rows, total, matched, mismatched, rate };
}


